import { useEffect, useRef } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { resolveDownload } from "../utils/downloadLinks";
import { sendDownloadClick } from "../utils/downloadClick";
import { redirectTo } from "../utils/redirect";

// The click is sent, then the visitor is on their way. The answer is not
// awaited for longer than this: a slow or dead API must never hold anyone up.
export const REDIRECT_DEADLINE_MS = 400;

export function DownloadRedirect() {
  const { source } = useParams();
  const [searchParams] = useSearchParams();
  const store = searchParams.get("store");

  const target = resolveDownload({
    source,
    store,
    userAgent: typeof navigator !== "undefined" ? navigator.userAgent : "",
    maxTouchPoints: typeof navigator !== "undefined" ? navigator.maxTouchPoints : 0,
  });

  const sent = useRef(false);
  const left = useRef(false);

  useEffect(() => {
    const go = () => {
      if (left.current) return;
      left.current = true;
      redirectTo(target.url);
    };
    const timer = setTimeout(go, REDIRECT_DEADLINE_MS);
    if (!sent.current) {
      sent.current = true;
      sendDownloadClick({ source: target.source, platform: target.platform }).then(go);
    }
    return () => clearTimeout(timer);
  }, [target.url, target.source, target.platform]);

  return (
    <main className="flex min-h-screen items-center justify-center px-6 text-center">
      <p className="font-dm text-base text-white/70">
        Taking you to the app.{" "}
        <a className="underline" href={target.url}>
          Tap here if nothing happens.
        </a>
      </p>
    </main>
  );
}
